import { ResponseRateType } from '../../../components/statistics';

export const getRateType = (rate: number): ResponseRateType => (rate > 0.6 ? 'high' : 'low');
